import { commitMutation, graphql } from 'react-relay';

const mutation = graphql`
  mutation RequestRecheckMutation($input: RequestRecheckInput!) {
    requestRecheck(input: $input) {
      status
    }
  }
`;

function commit(environment, email, locale, mediaId, startnumber, callback) {
  return commitMutation(environment, {
    mutation,
    variables: {
      input: {
        email,
        locale,
        mediaId,
        startnumber,
      },
    },
    onCompleted: (response, errors) => {
      if (errors) {
        callback && callback(errors[0]);
      } else {
        callback && callback(null, response.requestRecheck.status);
      }
    },
    onError: err => {
      callback && callback(err);
    },
  });
}

export default { commit };
